import * as React from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';

import SVG from 'react-inlinesvg';
import styles from './Login.module.scss';
import { Field, Form } from 'react-final-form';
import { Button } from '../../components/Button/Button';
import { loginActions } from '../../store/login/actions';
import { Base64 } from 'js-base64';
import { bindActionCreators, Dispatch } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { get } from 'lodash';
import { Link } from 'react-router-dom';
import { AppleButtonConnected } from './AppleButton';
import { tr } from '../../utils/translations/translator';
import { useTranslation } from 'react-i18next';
import show from '../../assets/icons/show.svg';
import { userSelector } from '../../store/tipster/selector';
import { RootState } from '../../store';
import smallLogo from '../../assets/icons/tipster-small-logo.svg';
interface DispatchProps {
  actions: {
    newLoginRequest: (a: string, b: string) => void;
    newFBLoginRequest: (s: string) => any;
  };
}
interface StateProps {
  user: any;
}
interface OwnProps {}
type LoginProps = OwnProps & StateProps & DispatchProps & RouteComponentProps;

export const Login: React.FC<LoginProps> = (props) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const required = (value: string) => (value ? undefined : tr(t, 'required'));
  const search = window.location.href.split('/login/sso?');
  const params = new URLSearchParams(search[1]);
  const redirect = params.get('redirect');

  const onSubmit = (d: any) => {
    props.actions.newLoginRequest(
      Base64.toBase64(`${d.username}:${d.password}`),
      redirect || '',
    );
  };

  return (
    <div className={styles.container}>
      {props.user ? (
        <form>
          <h2>
            Welcome to
            <br></br> TipsterChat
          </h2>
        </form>
      ) : (
        <Form
          onSubmit={onSubmit}
          //@ts-ignore
          render={({ handleSubmit, invalid }) => (
            <form onSubmit={handleSubmit}>
              <SVG src={smallLogo} />
              <h2>
                {tr(t, 'login_title')}
                <br></br> TipsterChat
              </h2>
              <div>
                <Field name="username" component="input" validate={required}>
                  {({ input, meta }) => (
                    <>
                      <input
                        {...input}
                        type="text"
                        placeholder={tr(t, 'login_username')}
                      />
                      {meta.error && meta.touched && (
                        <span className={styles.error}>{meta.error}</span>
                      )}
                    </>
                  )}
                </Field>
              </div>
              <div>
                <Field name="password" component="input" validate={required}>
                  {({ input, meta }) => (
                    <div className={styles.passWrapper}>
                      <input
                        {...input}
                        type={showPassword ? 'text' : 'password'}
                        placeholder={tr(t, 'login_password')}
                      />
                      <button
                        className={
                          showPassword ? styles.active : styles.unactive
                        }
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <SVG src={show} />
                      </button>
                      {meta.error && meta.touched && (
                        <span className={styles.error}>{meta.error}</span>
                      )}
                    </div>
                  )}
                </Field>
              </div>
              <Button
                disabled={invalid}
                type={'submit'}
                action={() => {}}
                text={tr(t, 'login_login')}
                theme={'primary'}
              />
              <div className={styles.pass}>
                <Link to="/recover-password">
                  {tr(t, 'login_recover-password')}
                </Link>
              </div>
              <AppleButtonConnected text={tr(t, 'login_apple-login')} />
              <Button
                text={tr(t, 'login_facebook-login')}
                theme={'primary'}
                className={styles.fbLogin}
                type={'button'}
                action={() => {
                  // @ts-ignore
                  FB.login(
                    function (response: any) {
                      const fbToken = get(response, [
                        'authResponse',
                        'accessToken',
                      ]);
                      if (fbToken && fbToken.length > 0) {
                        props.actions.newFBLoginRequest(fbToken);
                      }
                    },
                    { scope: 'public_profile,email' },
                  );
                }}
              />
            </form>
          )}
        />
      )}
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  user: userSelector(state),
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    {
      newLoginRequest: loginActions.loginRequestAction,
      newFBLoginRequest: loginActions.fbLoginRequest,
    },
    dispatch,
  ),
});

export const LoginConnected = withRouter(
  connect<StateProps, OwnProps, DispatchProps, RootState>(
    mapStateToProps,
    mapDispatchToProps,
  )(Login),
);
